import logo from '../assets/logo.svg';
import resume from "../assets/resume.pdf"

export default function Navbar() {
    return (
    <div className='glass fixed z-50 w-full top-0 left-0 px-8 py-3 lg:px-20 xl:px-36 border-b border-white/5'>
        <div className="flex justify-between items-center text-white">
            <img src={logo} className="App-logo w-10 rounded-full" alt="logo" />
            <ul className="hidden md:flex gap-1">
            <li><a href="#home" className="px-4 py-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-all duration-300 text-sm">About</a></li>
            <li><a href="#skills" className="px-4 py-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-all duration-300 text-sm">Skills</a></li>
            <li><a href="#employment" className="px-4 py-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-all duration-300 text-sm">Employment</a></li>
            </ul>
            <a href={resume} rel="noreferrer" target="_blank" className="relative group px-5 py-2 rounded-full text-sm font-semibold overflow-hidden">
              <span className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-cyan-500 transition-all duration-300 group-hover:opacity-90"></span>
              <span className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-cyan-500 blur-lg opacity-40 group-hover:opacity-60 transition-all duration-300"></span>
              <span className="relative z-10">Resume</span>
            </a>
        </div>
    </div>
    )
}
